import { Link } from "react-router-dom";
import ProductPhoto from "./ProductPhoto";
import type { Product } from "../types";
import { categoryLabel } from "../types";

// Горизонтальная лента мини-карточек (похожие товары, недавно просмотренные).
// Показывает бейдж статуса для недоступных товаров.
export default function ProductScroller({
  title,
  products,
}: {
  title: string;
  products: Product[];
}) {
  if (!products.length) return null;

  return (
    <section style={{ margin: "20px 0 4px" }}>
      {/* Заголовок ленты — подпись секции: между дисплейным слоем и микро в
          языке ничего нет, а 34px внутри страницы товара перебили бы название. */}
      <h3 className="section-label">{title}</h3>
      <div
        style={{
          display: "flex",
          gap: 10,
          overflowX: "auto",
          paddingBottom: 6,
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
        }}
      >
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            style={{ flex: "0 0 130px", width: 130, textDecoration: "none", color: "inherit" }}
          >
            <div style={{ position: "relative", borderRadius: 12, overflow: "hidden" }}>
              <ProductPhoto productId={p.id} alt={p.title ?? p.sku} variant="thumb" blur={p.blur} />
              {p.status !== "available" && (
                <span
                  className="pill"
                  style={{
                    position: "absolute",
                    top: 6,
                    left: 6,
                    background: p.status === "sold" ? "rgba(0,0,0,0.6)" : "var(--accent)",
                    color: "#fff",
                    fontSize: 10,
                    padding: "2px 7px 1px",
                  }}
                >
                  {p.status === "sold" ? "Продано" : "Бронь"}
                </span>
              )}
            </div>
            <p
              style={{
                margin: "6px 0 2px",
                fontSize: 13,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {p.title ?? categoryLabel(p.category)}
            </p>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "var(--accent)" }}>
              {Math.round(p.price).toLocaleString("ru-RU")} ₽
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}
